const PRICING_PLANS_STARTER = [
  "Ideal for new startups",
  "Up to 50 transactions a month",
  "Bank and credit card reconciliation",
  "Monthly profit & loss report",
  "Email support",
];
const PRICING_PLANS_GROWTH = [
  "Up to 150 transactions a month",
  "Everything in Starter",
  "Invoice and bill tracking",
  "Monthly 30-minute review call",
  "Payment apps connected (Stripe, Square, Shopify)",
];
const PRICING_PLANS_PLUS = [
  "Up to 300 transactions a month",
  "Everything in Growth",
  "Job, project or truck cost tracking",
  "Year-end package for your tax preparer",
  "Priority support",
];

export const PRICING_LIST_TWO = [
  {
    id: 1,
    isPopular: false,
    title: "Starter",
    prices: { monthly: 250, yearly: 119 },
    plans: PRICING_PLANS_STARTER,
    href: "/contact",
  },
  {
    id: 2,
    isPopular: true,
    title: "Growth",
    prices: { monthly: 450, yearly: 499 },
    plans: PRICING_PLANS_GROWTH,
    href: "/contact",
  },
  {
    id: 3,
    isPopular: false,
    title: "Plus",
    prices: { monthly: 750, yearly: 999 },
    plans: PRICING_PLANS_PLUS,
    href: "/contact",
  },
];

export const PRICING_LIST_THREE = [
  {
    id: 1,
    isPopular: false,
    title: "Basic Plan",
    prices: { monthly: 19, yearly: 119 },
    plans: PRICING_PLANS_STARTER,
    href: "/contact",
    icon: "flaticon-rocket",
  },
  {
    id: 2,
    isPopular: true,
    title: "Team Plan",
    prices: { monthly: 39, yearly: 339 },
    plans: PRICING_PLANS_GROWTH,
    href: "/contact",
    icon: "flaticon-inspiration",
  },
  {
    id: 3,
    isPopular: false,
    title: "Enterprise Plan",
    prices: { monthly: 89, yearly: 899 },
    plans: PRICING_PLANS_PLUS,
    href: "/contact",
    icon: "flaticon-briefcase-1",
  },
];

export const PRICING_LIST_ONE = [
  {
    id: 1,
    isPopular: false,
    title: "Basic Plan",
    prices: { monthly: 19, yearly: 119 },
    plans: PRICING_PLANS_STARTER,
    href: "/contact",
  },
  {
    id: 2,
    isPopular: true,
    title: "Standard Plan",
    prices: { monthly: 39, yearly: 329 },
    plans: PRICING_PLANS_GROWTH,
    href: "/contact",
  },
  {
    id: 3,
    isPopular: false,
    title: "Business Plan",
    prices: { monthly: 99, yearly: 899 },
    plans: PRICING_PLANS_PLUS,
    href: "/contact",
  },
];
